<template>
  <div v-if="category">
    <AppSection top>
      <AppContainer>
        <BlogBreadcrumbs :current="category.name" />
        <h1 class="pt-5">{{ category.name }}</h1>
        <ArticleCards v-if="posts" :posts :columns="3" has-excerpt />
      </AppContainer>
    </AppSection>
  </div>
</template>

<script setup lang="ts">
const { params } = useRoute();
const { getCatgory, getPosts } = useWordpress();
const { data: categories } = await useAsyncData(() => getCatgory(params.category as string));
const category = categories.value?.[0];
if (!category) {
  throw createError({ fatal: true, statusCode: 404, message: `Category "${params.category}" not found` });
}
const { t } = useI18n();
const { tt } = useLocalization();
const slug = decodeURIComponent(category.slug);
usePageHead({
  title: t(`blog_categories.${slug}.title`, tt('blog.title')),
  description: t(`blog_categories.${slug}.meta_desc`, tt('blog.meta_desc')),
  type: 'article',
  image: {
    src: '/images/desk.webp',
    width: 496,
    height: 750,
    alt: tt('contact_page.desk')
  }
});

const { data: posts } = await useAsyncData(() => getPosts({
  category: category.id
}));
</script>